export const MARKETPLACE_CHAIN_ID = Number(process.env.NEXT_PUBLIC_MARKETPLACE_CHAIN_ID || "")
